import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CiiComponent } from './cii.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { ExpansionPanelModule } from 'src/app/shared/components/expansion-panel/expansion-panel.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { TableViewCIIComponent } from './table-view-cii/table-view-cii.component';
import { InsideBdnViewComponent } from './inside-bdn-view/inside-bdn-view.component';
import { CiiRoutingModule } from './cii-routing.module';
import { CiiPredictiveAllowanceModalModule } from 'src/app/shared/components/cii-predictive-allowance-modal/cii-predictive-allowance-modal.module';

@NgModule({
  declarations: [
    CiiComponent,
    TableViewCIIComponent,
    InsideBdnViewComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDropdownModule,
    CustomDatePickerModule,
    CustomTimpickerModule,
    CustomInputModule,
    MatPaginatorModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    ExpansionPanelModule,
    CiiRoutingModule,
    CiiPredictiveAllowanceModalModule
  ],
  exports: [CiiComponent]
})
export class CiiModule { }
